import DrawerButton from "components/ui/DrawerButton";
import Button from "hardcover-ui/components/Button";
import { ButtonThemeProps } from "hardcover-ui/theme/components/button";
import { useDispatch } from "react-redux";
import { uiActions } from "store/ui/uiSlice";

export interface Props {
  objectType: string;
  objectId: number;
  description: string;
  className?: string;
  children: React.ReactNode;
  close?: () => void;
  size?: ButtonThemeProps["size"];
  variant?: ButtonThemeProps["variant"];
  drawer?: boolean;
}

export default function ReportButton({ variant, size, drawer, objectType, objectId, description, children, close, className }: Props) {
  const dispatch = useDispatch();

  const startReport = () => {
    if(close) {
      close();
    }
    dispatch(uiActions.startReport({ objectType, objectId, description }));
  }

  const ButtonElement = drawer ? DrawerButton : Button;

  return (
    <ButtonElement
      size={size ?? drawer ? "sm" : "md"}
      variant={variant}
      className={className}
      onClick={() => startReport()}
    >
      {children}
    </ButtonElement>
  );
}
